<template>
  <div style="width: 100%; height: 100%; padding: 20px">
    <div class="welcome">
      {{ $t('home.welcomeanjunKD') }}
    </div>
    <div class="favorites">
      <div class="flx-between">
        <div style="font-size: 20px; font-weight: bold">{{ $t('home.funcFavorites') }}</div>
        <div class="point" @click="showSetFavoritesItemDialog">
          <i class="el-icon-setting" style="font-size: 25px" />
        </div>
      </div>
      <div>
        <draggable
          v-model="searchMenuList"
          animation="100"
          chosen-class="chosen"
          class="flex-start favoritesList"
          drag-class="tag-drag"
          ghost-class="tag-ghost"
          item-key="id"
          @change="draggableChange"
        >
          <div
            v-for="(i, index) in searchMenuList"
            :key="index"
            class="favoritesItem"
            @click="toMenu(i)"
          >
            <span class="favoritesName">{{ i.name }}</span>
          </div>
        </draggable>
      </div>
    </div>
    <div class="favorites" style="height: 580px; overflow: auto">
      <div style="margin-bottom: 10px; font-size: 18px; font-weight: bold">{{ $t('GlobalSetObj.announcement') }}</div>
      <div>
        <div
          v-for="(item, index) in messageInfoList.topMessageList"
          :key="index"
          class="itemInfo"
          style="margin-bottom: 15px"
        >
          <div class="infoTag">
            <el-tag type="danger">{{ $t('home.pinToTop') }}</el-tag>
          </div>
          <div>
            <i class="iconfont icon-gonggao" style="font-size: 16px" />
            <span style="margin-left: 10px; color: #777777">{{ item.createTime }}</span>
          </div>
          <div
            class="infoTitleItem"
            style="
              color: #00A551 !important;
              margin: 5px 0 7px 25px;
              font-weight: bold;
              font-size: 18px;
            "
          >
            {{ item.title }}
          </div>
          <div style="margin-left: 25px" @click.stop="getImgSrc" v-html="item.messageContent" />
        </div>
        <!--   第二行        -->
        <div
          v-for="(item, index) in messageInfoList.normalMessageList"
          :key="index"
          class="itemInfo"
          style="margin-bottom: 15px"
        >
          <div>
            <i class="iconfont icon-gonggao" style="font-size: 16px" />
            <span style="margin-left: 10px; color: #777777">{{ item.createTime }}</span>
          </div>
          <div
            class="infoTitleItem"
            style="
              color: #00A551 !important;
              margin: 5px 0 7px 25px;
              font-weight: bold;
              font-size: 18px;
            "
          >
            {{ item.title }}
          </div>
          <div style="margin-left: 25px" @click.stop="getImgSrc" v-html="item.messageContent" />
        </div>
      </div>
    </div>
    <favorites
      ref="favoritesRef"
      :pc-menu-list="menuList"
      :show-menu-list="searchMenuList"
      @childrenSearch="childrenSearch"
    />
    <!-- 欢迎使用安骏跨境物流系统 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :title="$t('login.changePwd')"
      :visible.sync="centerDialogVisible"
      center
      width="500px"
    >
      <!-- 请设置新的密码 -->
      <p class="color-DF303A">{{ $t('GlobalSetObj.changePasswordMonth') }}</p>

      <el-form
        ref="ruleForm" :model="ruleForm" :rules="rules"
        label-width="100px"
      >
        <!-- 旧密码 -->
        <el-form-item :label="$t('changepwd.oldPwd')" prop="oldPassword">
          <!-- 请输入旧密码 -->
          <el-input
            v-model="ruleForm.oldPassword"
            :placeholder="$t('changepwd.inputOldPwd')"
            show-password
          />
        </el-form-item>
        <!-- 新密码 -->
        <el-form-item :label="$t('changepwd.newPwd')" prop="newPassword">
          <!-- 请输入新密码 -->
          <el-input
            v-model.trim="ruleForm.newPassword"
            :placeholder="$t('changepwd.inputNewPwd')"
            maxlength="12"
            minlength="8"
            show-password
          />

          <!-- 必须由 4-16 位小写或大写字母、数字组成 -->
          <span class="tips">{{ $t('changepwd.inputHint') }}</span>
        </el-form-item>
        <!-- 确认密码 -->
        <el-form-item :label="$t('changepwd.checkPwd')" prop="newPasswordConfirm">
          <!-- 请再次输入新密码 -->
          <el-input
            v-model.trim="ruleForm.newPasswordConfirm"
            :placeholder="$t('changepwd.inputConfirmCode')"
            maxlength="12"
            minlength="8"
            show-password
          />
        </el-form-item>
        <el-form-item>
          <!-- 确认 -->
          <el-button
            type="primary" @click="submitForm('ruleForm')"
          >{{ $t('changepwd.confirm') }}
          </el-button>
          <!-- 重置 -->
          <el-button @click="resetForm('ruleForm')">{{ $t('GlobalSetObj.cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 图片预览 -->
    <ElImageViewer v-if="showViewer" :on-close="closeViewer" :url-list="imgArr" />
  </div>
</template>

<script>
import { asyncGetOrganizationTree, asyncGetPositionList, asyncGetUserAdditionalInformation } from '@/utils/asyncTools';
import { weakPwd } from '@/utils/validate';
import { apiResetPassword, collectMenu, getProviderNoticeMsg, queryMenu } from '@/api/user';
import { GlobalSetObj } from '@/lang/type/global';
import favorites from '@/views/dashboard/component/favorites.vue';
import md5 from 'js-md5';
import draggable from 'vuedraggable';
import { RouterObj } from '@/lang/type/route';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
  name: 'IndexSorting',
  components: {
    favorites,
    draggable,
    ElImageViewer
  },
  data() {
    return {
      showViewer: false,
      imgArr: [],
      routerObjLang: RouterObj,
      searchMenuList: [],
      menuList: [],
      // 修改密码弹窗
      centerDialogVisible: false,
      ruleForm: {
        newPassword: '', // 新密码
        newPasswordConfirm: '', // 确认新密码
        oldPassword: '', // 旧密码
        userId: this.$store.getters.userId
      },
      rules: {
        oldPassword: [
          { required: true, message: this.$t('changepwd.inputOldPwd'), trigger: ['blur', 'change'] }
        ],
        newPassword: [
          {
            required: true,
            message: this.$t('changepwd.inputNewPwd'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const { oldPassword } = this.ruleForm;
              if (!weakPwd(value)) {
                callback(new Error(this.$t('changepwd.requestedInputCode')));
              } else if (value === oldPassword) {
                callback(new Error(this.$t('changepwd.newCodeNotOldCode')));
              } else {
                callback();
              }
            }
          }
        ],
        newPasswordConfirm: [
          // { required: true, validator: newPasswordConfirmCheck, trigger: 'blur' }
          {
            required: true,
            message: this.$t('changepwd.inputConfirmCode'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const { newPassword } = this.ruleForm;
              if (value === '') {
                callback(new Error(this.$t('changepwd.inputConfirmCode')));
                return;
              }
              if (newPassword !== value) {
                callback(new Error('确认密码与新密码不相同'));
                return;
              }
              callback();
            }
          }
        ]
      },
      messageInfoList: {
        normalMessageList: [],
        topMessageList: []
      }
    };
  },
  computed: {
    GlobalSetObj() {
      return GlobalSetObj;
    }
  },
  async created() {
    this.openSearchMenu();
    this.childrenSearch();
    this.getProviderNoticeMsgList();
    // 获取基本信息
    const arr = [
      asyncGetUserAdditionalInformation(),
      asyncGetOrganizationTree(),
      asyncGetPositionList()
    ];
    await Promise.all(arr);
    // this.$store.getters.passwordLastModified为年月日时分秒，转换成时间戳大于当前时间戳三十天时做判断
    const passwordLastModified = new Date(this.$store.getters.passwordLastModified).getTime();
    const now = new Date().getTime();
    if (now - passwordLastModified > 30 * 24 * 60 * 60 * 1000) {
      this.centerDialogVisible = true;
    } else {
      this.centerDialogVisible = false;
    }
  },
  methods: {
    normalizeBrandHtml(content) {
      if (!content) {
        return '';
      }
      return content
        .replace(/#409eff/gi, '#00A551')
        .replace(/rgb\(\s*64\s*,\s*158\s*,\s*255\s*\)/gi, 'rgb(0, 165, 81)')
        .replace(/rgba\(\s*64\s*,\s*158\s*,\s*255\s*,/gi, 'rgba(0, 165, 81,');
    },
    // 查看图片
    getImgSrc(e) {
      if (e.target.nodeName !== 'IMG') {
        return;
      }
      this.imgArr = [e.target.src];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    // 查询公告
    getProviderNoticeMsgList() {
      getProviderNoticeMsg({
        systemType: 1
      }).then((res) => {
        if (res.code === 200) {
          this.messageInfoList.normalMessageList = res.data?.normalMessageList;
          this.messageInfoList.topMessageList = res.data?.topMessageList;
          this.messageInfoList.normalMessageList.forEach((item) => {
            item.messageContent = this.normalizeBrandHtml(item.msgData).replace(/<p>/g, '<p style="margin: 0;">');
          });
          this.messageInfoList.topMessageList.forEach((item) => {
            item.messageContent = this.normalizeBrandHtml(item.msgData).replace(/<p>/g, '<p style="margin: 0;">');
          });
        }
      });
    },
    //  查询收藏夹
    childrenSearch() {
      const data = {
        source: 1,
        userId: this.$store.state.user.id
      };
      this.searchMenuList = [];
      queryMenu(data).then((res) => {
        if (res.code === 200) {
          const arr = res.data.menuTitle.map((item, index) => {
            const obj = this.menuList.find((item1) => item1.title === item);
            if (obj) {
              return obj;
            }
          });
          arr.forEach((item) => {
            if (item) {
              this.searchMenuList.push(item);
            }
          });
        }
      });
    },
    // 点击删除
    delMenu(val) {
      console.log(val, 'delMenu');
      console.log(this.searchMenuList, 'this.searchMenuList');
      const index = this.searchMenuList.findIndex((item) => item.title === val.title);
      console.log(index, 'index');
      if (index !== -1) {
        this.searchMenuList.splice(index, 1);
        const arr = this.searchMenuList.map((item) => item.title);
        console.log(arr, 'arr');
        this.setFavoritesItem(arr);
      }
    },
    toMenu(item) {
      this.$router.push(item.path);
    },
    draggableChange() {
      console.log(this.searchMenuList, 'draggableChange');
      const arr = this.searchMenuList.map((item) => item.title);
      console.log(arr, 'arr');
      this.setFavoritesItem(arr);
    },
    // 设置收藏夹
    setFavoritesItem(arr) {
      const data = {
        source: 1,
        userId: this.$store.state.user.id,
        menuTitle: arr
      };
      collectMenu(data).then((res) => {
        if (res.code === 200) {
          this.childrenSearch();
        }
      });
    },
    // 点击设置收藏夹
    showSetFavoritesItemDialog() {
      this.$refs.favoritesRef.showSetFavoritesItemDialog();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.asyncResetPassword();
      });
    },
    resetForm(formName) {
      this.centerDialogVisible = false;
      this.$refs[formName].resetFields();
      this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    openSearchMenu() {
      const arr = this.extractRoutes(this.$store.getters.addRoutes);
      // 去到数组第一个
      arr.splice(0, 1);
      arr.forEach((item) => {
        try {
          if (this.$i18n.locale !== 'zh') {
            item.name = this.routerObjLang[item.title].pu;
          } else {
            item.name = this.routerObjLang[item.title].zh;
          }
        } catch (error) {
          console.log(error, 'error');
        }
      });
      this.menuList = arr;
      console.log(arr, 'arr');
    },
    // 递归过滤
    extractRoutes(routes, parentPath = '', result = [], leave = 0) {
      routes.forEach((route) => {
        let currentPath = route.path;
        if (parentPath && currentPath) {
          currentPath = `${parentPath}/${currentPath}`;
        }
        const title = route.meta && route.meta.title;
        const fillterRouter = route.fillterRouter;
        if (title && currentPath && leave > 0) {
          // 判断把一级的路由过滤
          if (fillterRouter !== true) {
            result.push({ title, path: currentPath, leave, fillterRouter });
          }
        }
        if (route.children && route.children.length > 0) {
          this.extractRoutes(route.children, currentPath, result, leave + 1);
        }
      });
      return result;
    },
    /**
     * 设置新密码
     */
    asyncResetPassword() {
      // const { newPassword, oldPassword } = this.ruleForm;
      const newPassword = md5(md5(this.ruleForm.newPassword));
      const oldPassword = md5(md5(this.ruleForm.oldPassword));
      const obj = {
        isVerification: 1, // 是否需要验证旧密码
        newPassword,
        oldPassword,
        id: this.$store.getters.userId
      };
      apiResetPassword(obj)
        .then((data) => {
          if (data.code === 200) {
            return this.$store.dispatch('user/logout');
          }
        })
        .then((data) => {
          this.$notify({
            title: this.$t('changepwd.succeed'),
            message: this.$t('changepwd.loginAgain'),
            type: 'success'
          });
          setTimeout(() => {
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.tips {
  color: #b4b2b2;
  font-size: 12px;
  line-height: 13px;
  display: inline-block;
}

.color-DF303A {
  color: #df303a;
  font-size: 14px;
  font-weight: bold;
}

@import './index.css';
</style>
